import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryField } from 'shared/summary/SummaryField';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { formatPhoneNumber } from 'shared/utils/phone';
import { slugs, useRentalSteps } from '../../app/steps';
import { EnumChoicesTypeInfoFragment, ErrorType } from '../../generated.graphql';
import { BaseSummaryProps } from './types';
import { getEnumDisplay, YesNoLabel } from './utils';


interface Props extends BaseSummaryProps {
  salutationEnum?: EnumChoicesTypeInfoFragment | null;
  residentStatusEnum?: EnumChoicesTypeInfoFragment | null
}


export const AboutMeSummary = ({ application, salutationEnum, residentStatusEnum }: Props) => {
  const steps = useRentalSteps({slug: slugs.aboutMe});
  const customer = application?.customer;
  const marketing = (<YesNoLabel value={application?.marketingConsent ?? false} />);
  
  const errors = application?.validation?.customer;
  const fields = ['firstName', 'lastName', 'email', 'phoneMobile', 'dob', 'licenceNo'];
  const isInvalid = !!errors?.find((e) => fields.indexOf(e.field ?? '') >= 0);

  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>About Me</SummaryHeader>
      {!customer ? <LoadingLabel alignment="left" /> : (
        <>
          <SummaryField field="title" value={getEnumDisplay(customer.title, salutationEnum)} errors={errors} />
          <SummaryField
            label="Name" 
            value={`${customer.firstName} ${customer.lastName}`.trim()}
            error={errors?.filter((e) => e?.field === 'firstName' || e?.field === 'lastName')
              .reduce<ErrorType | null>((e, c) => {
                if (c.messages.length > 0) {
                  return {
                    field: '',
                    messages: e?.messages ?? c.messages,
                  }
                }
                return e;
              }, null)
            }
          />
          <SummaryField data={customer} field="email" errors={errors} />
          <SummaryField label="Mobile number" value={formatPhoneNumber(customer.phoneMobile)} errors={errors} />
          <SummaryField data={customer} label="Date of birth" field="dob" errors={errors} />
          <SummaryField label="Resident status" value={getEnumDisplay(application?.residentStatus, residentStatusEnum)} />
          <SummaryField data={customer} label="Drivers license number" field="licenceNo" errors={errors} optional />
          {application?.inStore === null ? (<div className="mt-2">Send me product updates and special offers: {marketing}</div>) : null}
        </>
      )}
    </SummarySection>
  );
}
